import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Check, ArrowRight } from 'lucide-react';
import { Layout } from '../Layout';
import { useActivationSteps } from '../../hooks/useActivationSteps';
import { SupportTicketModal } from './SupportTicketModal';

export function AanDeSlagPanel() {
  const { steps, nextStep, allDone, loading, error } = useActivationSteps();
  const [helpOpen, setHelpOpen] = useState(false);
  return (
    <Layout showSidebar maxWidth="md">
      <div className="max-w-2xl mx-auto px-4 py-6">
        <h1 className="text-2xl font-bold text-[#231F20] mb-1">Aan de slag</h1>
        <p className="text-gray-600 mb-6">Zo haal je het meeste uit dibbi, stap voor stap.</p>

        {loading && <p className="text-gray-500">Je voortgang laden...</p>}
        {error && <p className="text-gray-500">We konden je voortgang even niet laden. Probeer het later nog eens.</p>}

        {!loading && !error && (
          <ol className="relative border-l-2 border-gray-200 ml-3 space-y-6">
            {steps.map((s) => {
              const isNext = nextStep?.key === s.key;
              return (
                <li key={s.key} className="ml-6">
                  <span className={`absolute -left-[11px] flex items-center justify-center w-5 h-5 rounded-full ring-4 ring-[#F2F2EF] ${s.done ? 'bg-green-500 text-white' : isNext ? 'bg-[#FF6B35] text-white' : 'bg-gray-300'}`}>
                    {s.done ? <Check className="w-3 h-3" /> : null}
                  </span>
                  <h3 className={`text-sm font-semibold ${s.done ? 'text-gray-400 line-through' : isNext ? 'text-[#231F20]' : 'text-gray-400'}`}>{s.title}</h3>
                  {isNext && (
                    <>
                      <p className="text-sm text-gray-600 mt-1 mb-3">{s.body}</p>
                      <Link to={s.ctaRoute} className="inline-flex items-center gap-2 bg-[#FF6B35] hover:bg-[#e85a20] text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors">
                        {s.ctaLabel} <ArrowRight className="w-4 h-4" />
                      </Link>
                    </>
                  )}
                </li>
              );
            })}
          </ol>
        )}

        {!loading && !error && allDone && (
          <div className="mt-6 bg-green-50 border border-green-200 rounded-xl p-5 text-center">
            <p className="text-green-800 font-semibold">Je bent helemaal op weg!</p>
            <p className="text-green-700 text-sm mt-1">Je hebt alle stappen afgerond. Mooi werk.</p>
          </div>
        )}

        {!loading && !error && (
          <div className="mt-8 bg-white border border-gray-200 rounded-xl p-5 flex items-center gap-4">
            <div className="flex-none w-12 h-12 rounded-full bg-[#FF6B35]/10 flex items-center justify-center text-2xl" aria-hidden>
              &#128075;
            </div>
            <div className="flex-1">
              <p className="text-sm font-semibold text-[#231F20]">Vastgelopen of een vraag?</p>
              <p className="text-sm text-gray-600 mt-0.5">Stel je vraag, we reageren snel per e-mail. Geen vraag is te gek.</p>
            </div>
            <button
              onClick={() => setHelpOpen(true)}
              className="flex-none bg-[#FF6B35] hover:bg-[#e85a20] text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors"
            >
              Stel je vraag
            </button>
          </div>
        )}
      </div>

      {helpOpen && <SupportTicketModal onClose={() => setHelpOpen(false)} />}
    </Layout>
  );
}
